import type { Provider } from '@/types';
import { claudeAdapter } from './claude';
import { geminiAdapter } from './gemini';
import { openaiAdapter } from './openai';
import type { LLMAdapter } from './types';

export const PROVIDER_ORDER: Provider[] = ['openai', 'gemini', 'claude'];
export const ADAPTERS: Record<Provider, LLMAdapter> = { openai: openaiAdapter, gemini: geminiAdapter, claude: claudeAdapter };
export const PROVIDER_LABEL: Record<Provider, string> = { openai: 'OpenAI', gemini: 'Gemini', claude: 'Claude' };
export const KEY_PLACEHOLDER: Record<Provider, string> = { openai: 'sk-…', gemini: 'AIza…', claude: 'sk-ant-…' };

export const FALLBACK_MODELS: Record<Provider, string[]> = {
  openai: ['gpt-5', 'gpt-5-mini', 'gpt-4.1'],
  gemini: ['gemini-3-pro', 'gemini-3-flash', 'gemini-2.5-pro'],
  claude: ['claude-opus-5', 'claude-sonnet-5', 'claude-haiku-4-5'],
};
export const MODELS_TTL_MS = 7 * 24 * 60 * 60 * 1000;

const LIGHT_TIER = /(^|[-_.])(haiku|flash|mini|nano)(?=$|[-_.])/i;

export function pickLightModel(models: string[], fallback: string): string {
  return models.find((m) => LIGHT_TIER.test(m)) ?? fallback;
}

export function pickDefaultModel(models: string[], previous?: string): string {
  if (previous && models.includes(previous)) return previous;
  return models.find((m) => /sonnet|opus|gpt-5(?!.*(mini|nano))|gemini-\d+(\.\d+)?-pro/i.test(m)) ?? models[0] ?? '';
}
